import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    fontSize: idsTokens.typography.font.size.sm,
    color: idsTokens.label.default.color.text,
    paddingTop: idsTokens.label.default.spacing.padding.top,
    paddingRight: idsTokens.label.default.spacing.padding.right,
    paddingLeft: idsTokens.label.default.spacing.padding.left,
    paddingBottom: idsTokens.label.default.spacing.padding.bottom,
    lineHeight: idsTokens.typography.lineHeight.base,
    '&.Mui-focused, &.Mui-error': {
      color: idsTokens.label.default.color.text,
    },
    '&.Mui-disabled': {
      pointerEvents: 'none',
    },
  },
  formControl: {
    transform: 'none',
    position: 'relative',
  },
  shrink: {
    transform: 'none',
  },
  animated: {
    transition: 'none',
  },
});
